
import { Config } from "../core/config"



const mostrar_error = (params) => {
    let {message} = params;
    if (!message)
        {
            message = "Ha ocurrido un error inesperado"
        }
        
    return /*html*/`
                 <div class="titulo insuficiente">
                    <h2> <strong>${message}</strong></h2>
                </div>
                <div class="caja-pdf">
                    <h4> <strong>Por favor, volvé a intentarlo</strong> </h4>
                    <hr>
                    <p> Si no pudiste resolver el problema, contactanos para que podamos ayudarte </p>
                    
                    <a class="consulta" href="https://micuenta.lanacion.com.ar/contactanos" target="_blank"> ENVIANOS TU CONSULTA </a>
                    <p>
                        O bien comunicate al: <strong>(011) 5199-4787</strong> <br>
                        desde el exterior a <a href="mailto:accesodigital@lanacion.com.ar">accesodigital@lanacion.com.ar</a>
                    </p>
                </div>`
}


module.exports = {
    mostrar_error: mostrar_error,
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/views/error.js